// src/HOC/SUBSCRIPTION/orderSummary.js
import { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Divider,
  Button,
  IconButton,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  getStepConnectorUtilityClass,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useHistory, useLocation } from "react-router-dom";
import axios from "../../axios-order";
import { toast } from "react-toastify";
import CWS from "../../asserts/images/new_logo.png";
import MSA from "./MSA";
import { Dialog } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";


const OrderSummary = () => {
  const history = useHistory();
  const location = useLocation();

  // Data passed from ARCCustomer via history.push
  const locationState = location.state;
  const orderItems = Array.isArray(locationState)
    ? locationState
    : [locationState];
  const orderData = orderItems[0] || {};

  const [quantity, setQuantity] = useState(1);
  const [licenseType, setLicenseType] = useState("renew");
  const [serialNo, setSerialNo] = useState("");
  const [termsChecked, setTermsChecked] = useState(false);
  const buttonContainerRef = useRef(null);
  const [showScrollButton, setShowScrollButton] = useState(true);
  const [authorisedName, setAuthorisedName] = useState("");
  const [authorisedEmail, setAuthorisedEmail] = useState("");
  const [authorisedContact, setAuthorisedContact] = useState("");
  const [authorisedDesignation, setAuthorisedDesignation] = useState("");
  const [termsDialogOpen, setTermsDialogOpen] = useState(false);
  const [gstinError, setGstinError] = useState("");
  const [pinCodeError, setPinCodeError] = useState("");
  const [mobileError, setMobileError] = useState("");
  console.log("state from localStorage -->", localStorage.getItem("state"));

  const [billingDetails, setBillingDetails] = useState({
    name: localStorage.getItem("entity_name") || "",
    email: localStorage.getItem("EmailId") || "",
    pinCode: localStorage.getItem("pinCode") || "",
    gstin: localStorage.getItem("gst") || "",
    mobile: localStorage.getItem("contact") || "",
    address: localStorage.getItem("address") || "",
    noGstin: false,
    country: localStorage.getItem("country") || "",
    city: localStorage.getItem("city") || "",
    state:
      localStorage.getItem("state") === "undefined"
        ? ""
        : localStorage.getItem("state") || "",
    gst: localStorage.getItem("gst"),
  });
  const [payLoading, setPayLoading] = useState(false);
  const [msaPdfBase64, setMsaPdfBase64] = useState(null);
  const [msaSignedName, setMsaSignedName] = useState("");
  const [msaSignedDesignation, setMsaSignedDesignation] = useState("");
  const [msaSignedEmail, setMsaSignedEmail] = useState("");
  const [msaSignedPhone, setMsaSignedPhone] = useState("");
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [iframeAuthForm, setIframeAuthForm] = useState({
    name: "",
    designation: "",
    mobile: "",
    email: "",
  });
  const [iframeAuthErrors, setIframeAuthErrors] = useState({});
  const [iframeValidEmail, setIframeValidEmail] = useState(true);
  const [validBillingEmail, setValidBillingEmail] = useState(true);
  const [fieldErrors, setFieldErrors] = useState({});
  const [dataMigrationChecked, setDataMigrationChecked] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [statesAvailable, setStatesAvailable] = useState(false);

  const baseAmount = orderData?.amount?.sub_total ?? 0;
  const gstCharges = orderData?.amount?.GST_charges ?? 0;
  const totalAmount = orderData?.amount?.total ?? 0;
  const features = orderData?.features ?? [];
  const addOn = orderData?.addOn ?? [];
  const planId = orderData?.plan_id ?? "0";
  const msaUrl = orderData?.msa_url ?? null;

  const handleBillingChange = (e) => {
    const { name, value, type, checked } = e.target;
    setBillingDetails((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "email") {
      const emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
      if (emailPattern.test(value)) {
        axios
          .get(`/validate_email/${value}`)
          .then((res) => {
            setValidBillingEmail(res.data);
          })
          .catch((error) => {
            console.error("Error Validating Email:", error);
          });
      } else {
        setValidBillingEmail(true);
      }
    }
  };

  const getCountries = () => {
    axios
      .get(`/get_countries_list/`)
      .then((res) => {
        if (res.data.status) {
          setCountries(res.data.data);
        }
      })
      .catch((error) => console.log(error));
  };

  const getStatesByCountry = (name) => {
    axios
      .get(`/get_state_list/${name}`)
      .then((res) => {
        if (res.data.status) {
          const transformedStates = res.data.data.map((state) => ({
            id: state.id,
            name: state.value,
            value: state.value,
          }));
          setStates(transformedStates);
          setStatesAvailable(true);
        } else {
          setStates([]);
          setStatesAvailable(false);
          setBillingDetails((prev) => ({ ...prev, state: "" }));
        }
      })
      .catch((error) => {
        console.log(error);
        setStates([]);
        setStatesAvailable(false);
      });
  };

  useEffect(() => {
    getCountries();
    const savedCountry = localStorage.getItem("country");
    if (savedCountry && savedCountry !== "undefined" && savedCountry !== "") {
      getStatesByCountry(savedCountry);
    }
  }, []);

  useEffect(() => {
    const fetchEntityBillingInfo = async () => {
      try {
        const res = await axios.get(
          `/get_complete_entity_data/${localStorage.getItem("business_entity_id")}`,
        );
        const entity = res.data.Entity;
        if (entity) {
          const composedAddress = [
            entity.flat_no,
            entity.road_street_name,
            entity.area,
          ]
            .filter(Boolean)
            .join(", ");

          setBillingDetails((prev) => ({
            ...prev,
            mobile:
              prev.mobile ||
              entity.user_contact_number ||
              entity.contact_number ||
              "",
            address: prev.address || composedAddress || entity.address || "",
            country: prev.country || entity.country || "",
            city: prev.city || entity.city || "",
            state: prev.state || entity.state || "",
            pinCode: prev.pinCode || entity.pincode || "",
          }));

          if (entity.country && (!localStorage.getItem("country") || localStorage.getItem("country") === "undefined")) {
            getStatesByCountry(entity.country);
          }

          if (entity.user_contact_number || entity.contact_number)
            localStorage.setItem(
              "contact",
              entity.user_contact_number || entity.contact_number,
            );
          if (entity.city) localStorage.setItem("city", entity.city);
          if (entity.state) localStorage.setItem("state", entity.state);
          if (entity.country) localStorage.setItem("country", entity.country);
          if (entity.pincode) localStorage.setItem("pinCode", entity.pincode);
          if (composedAddress) localStorage.setItem("address", composedAddress);
        }
      } catch (err) {
        console.error("Failed to fetch entity billing info:", err);
      }
    };
    fetchEntityBillingInfo();
  }, []);

  const postPaymentHandler = async () => {
    if (isSubscriptionOrder) {
      toast.success(
        <div style={{ textAlign: "center", padding: "10px 5px" }}>
          <div
            style={{ fontSize: "18px", fontWeight: 700, marginBottom: "8px" }}
          >
            Thank you for subscribing!
          </div>
          <div style={{ fontSize: "15px", fontWeight: 400, lineHeight: "1.5" }}>
            Your account has been successfully activated. You will now be
            redirected to the production portal.
          </div>
        </div>,
        {
          autoClose: 3000,
          position: "top-center",
          style: {
            minWidth: "380px",
            padding: "20px",
            fontSize: "15px",
          },
        },
      );
    }

    if (orderData?.description === "PAN_TO_TAN_FETCHING") {
      uploadTanPostApiHandler();
    } else if (orderData?.description === "PAN_TO_TAN_FETCHING_VENDOR") {
      uploadVendorTanPostApiHandler();
    } else if (orderData?.description === "26AS_FORM_AUTO_DOWNLOAD") {
      autoDownload26AS();
    } else if (orderData?.description === "GSTR1_AUTO_DOWNLOAD") {
      autoDownloadGstr1();
    } else if (orderData?.description === "GSTR2A_AUTO_DOWNLOAD") {
      autoDownloadGstr2a();
    } else if (orderData?.description === "GSTR2B_AUTO_DOWNLOAD") {
      autoDownloadGstr2b();
    } else if (orderData?.description === "GSTR3B_AUTO_DOWNLOAD") {
      autoDownloadGstr3b();
    } else if (orderData?.description === "GSTR8A_AUTO_DOWNLOAD") {
      autoDownloadGstr8a();
    } else if (orderData?.description === "IMS_AUTO_DOWNLOAD") {
      autoDownloadIms();
    } else if (orderData?.description === "GSTR1_FILING_REPORT_GENERATION") {
      generateGstr1FilingReport();
    } else {
      try {
        // if (msaPdfBase64) {
        //   await axios.post("/save_subscription_pdfs", {
        if (msaUrl && msaSignedName) {
          await axios.post("/save_subscription_pdfs", {
            // pdf: msaPdfBase64,
            business_entity_id: localStorage.getItem("business_entity_id"),
            // gst: billingDetails.gstin,
            authorised_name: msaSignedName,
            authorised_email: msaSignedEmail,
            authorised_designation: msaSignedDesignation,
            authorised_phone: msaSignedPhone,
            to_email: billingDetails.email,
            dataTransfer: dataMigrationChecked,
          });
        }
      } catch (err) {
        console.error("Failed to save subscription PDF:", err);
      }

      try {
        const userid = localStorage.getItem("user_id");
        await axios.get(`/logout/${userid}`);
      } catch (err) {
        console.error("Logout failed:", err);
      }

      localStorage.clear();
      window.location.href = "https://dev.cappitallwant.com/";
    }
  };

  const handleTermsScroll = () => {
    const dialog = document.querySelector(".MuiDialog-paper");
    if (dialog) {
      const { scrollTop, scrollHeight, clientHeight } = dialog;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        setShowScrollButton(false);
      } else {
        setShowScrollButton(true);
      }
    }
  };

  useEffect(() => {
    if (!termsDialogOpen) return;
    const checkDialog = () => {
      const dialog = document.querySelector(".MuiDialog-paper");
      if (dialog) {
        dialog.addEventListener("scroll", handleTermsScroll);
        handleTermsScroll();
      } else {
        setTimeout(checkDialog, 100);
      }
    };
    checkDialog();
    return () => {
      const dialog = document.querySelector(".MuiDialog-paper");
      if (dialog) dialog.removeEventListener("scroll", handleTermsScroll);
    };
  }, [termsDialogOpen]);

  const uploadTanPostApiHandler = () => {
    console.log(
      "\nINSIDE uploadTanPostApiHandler. Calling API to get Karza TANs...",
    );
    axios
      .get(`/karza_tan/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (res.data && res.data.status === true) {
          toast.success(res.data.Message, {
            autoClose: 3000,
          });
          history.goBack();
        } else {
          toast.error(res.data.Message, {
            autoClose: 3000,
          });
          history.goBack();
        }
      });
  };

  const autoDownload26AS = () => {
    axios
      .post(`/auto_download_26as_repository`, {
        assessment_year: orderData?.fy,
        business_entity_id: localStorage.getItem("business_entity_id"),
      })
      .then(() => {
        toast.success("26AS auto download started");
        history.goBack();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Auto download failed");
        history.goBack();
      });
  };

  const uploadVendorTanPostApiHandler = () => {
    console.log(
      "\nINSIDE uploadVendorTanPostApiHandler. Calling API to get Karza Vendor TANs...",
    );
    axios
      .get(`/karza_vendor_tan/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (res.data && res.data.status === true) {
          toast.success(res.data.Message, {
            autoClose: 3000,
          });
          history.goBack();
        } else {
          toast.error(res.data.Message, {
            autoClose: 3000,
          });
          history.goBack();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Failed to update vendor TAN.");
        history.goBack();
      });
  };

  const autoDownloadGstr1 = () => {
    const entity_id = localStorage.getItem("business_entity_id");
    const url = orderData?.usePassThrough
      ? `/get_gstr1_autodownload_pass_through_response_data`
      : `${process.env.REACT_APP_BACKEND_BASE_URL}/gstDownload/gstr1download/`;

    const payload = orderData?.usePassThrough
      ? {
        entity_id,
        gstin: orderData?.gstin,
        fromRetPeriod: orderData?.fromRetPeriod,
        toRetPeriod: orderData?.toRetPeriod,
      }
      : (() => {
        const fd = new FormData();
        fd.append('entity_id', entity_id);
        fd.append('fromRetPeriod', orderData?.fromRetPeriod);
        fd.append('toRetPeriod', orderData?.toRetPeriod);
        return fd;
      })();

    axios
      .post(url, payload)
      .then((res) => {
        const d = res.data;
        if (d.message_type === 'success') {
          toast.success(d.message || "GSTR-1 downloaded successfully");
        } else {
          toast.error(d.message || "Download failed");
        }
        history.goBack();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Auto download failed");
        history.goBack();
      });
  };

  const autoDownloadGstr2a = () => {
    const entity_id = localStorage.getItem("business_entity_id");
    const usePassThrough = orderData?.usePassThrough;
    const url = usePassThrough
      ? `/get_gstr2a_autodownload_pass_through_response_data`
      : `${process.env.REACT_APP_BACKEND_BASE_URL}/gstDownload/gstr2adownload/`;

    const payload = usePassThrough
      ? {
        entity_id,
        gstin: orderData?.gstin,
        fromRetPeriod: orderData?.fromRetPeriod,
        toRetPeriod: orderData?.toRetPeriod,
      }
      : (() => {
        const fd = new FormData();
        fd.append('entity_id', entity_id);
        fd.append('fromRetPeriod', orderData?.fromRetPeriod);
        fd.append('toRetPeriod', orderData?.toRetPeriod);
        return fd;
      })();

    axios
      .post(url, payload)
      .then((res) => {
        const d = res.data;
        if (usePassThrough) {
          if (d.status === false && d.message) {
            toast.error(d.message);
          } else if ((d.status === "success" || d.message_type === 'success') && d.message) {
            toast.success(d.message);
          } else {
            toast.error(d.message || "Download failed");
          }
        } else {
          if (d.message_type === 'success') {
            toast.success(d.message || "GSTR-2A downloaded successfully");
          } else {
            toast.error(d.message || "Download failed");
          }
        }
        history.goBack();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Auto download failed");
        history.goBack();
      });
  };

  const autoDownloadGstr2b = () => {
    const entity_id = localStorage.getItem("business_entity_id");
    const usePassThrough = orderData?.usePassThrough;
    const url = usePassThrough
      ? `/get_gstr2b_autodownload_pass_through_response_data`
      : `${process.env.REACT_APP_BACKEND_BASE_URL}/gstDownload/gstr2bdownload/`;

    const payload = usePassThrough
      ? {
        entity_id,
        gstin: orderData?.gstin,
        fromRetPeriod: orderData?.fromRetPeriod,
        toRetPeriod: orderData?.toRetPeriod,
      }
      : (() => {
        const fd = new FormData();
        fd.append('entity_id', entity_id);
        fd.append('fromRetPeriod', orderData?.fromRetPeriod);
        fd.append('toRetPeriod', orderData?.toRetPeriod);
        return fd;
      })();

    axios
      .post(url, payload)
      .then((res) => {
        const d = res.data;
        if (usePassThrough) {
          if (d.status === false && d.message) {
            toast.error(d.message);
          } else if ((d.status === "success" || d.message_type === 'success') && d.message) {
            toast.success(d.message);
          } else {
            toast.error(d.message || "Download failed");
          }
        } else {
          if (d.message_type === 'success') {
            toast.success(d.message || "GSTR-2B downloaded successfully");
          } else {
            toast.error(d.message || "Download failed");
          }
        }
        history.goBack();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Auto download failed");
        history.goBack();
      });
  };

  const autoDownloadGstr3b = () => {
    const url = `/gstr3b/passthrough/repository`;
    const payload = {
      business_entity_id: orderData?.business_entity_id,
      fromRetPeriod: orderData?.fromRetPeriod,
      toRetPeriod: orderData?.toRetPeriod,
      gstin: orderData?.gstin,
    };

    axios
      .post(url, payload)
      .then((res) => {
        const d = res.data;
        if (d.message_type && d.message) {
          toast[d.message_type === 'success' ? 'success' : 'error'](d.message);
        } else if (d.status === "error" && d.message) {
          toast.error(d.message);
        } else if (typeof d.status === 'boolean' && d.message) {
          toast[d.status ? 'success' : 'error'](d.message);
        } else {
          toast.success("GSTR-3B downloaded successfully");
        }
        history.goBack();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          const errData = err.response.data;
          toast[errData.status === true ? 'success' : 'error'](errData.message);
        } else {
          toast.error("Auto download failed");
        }
        history.goBack();
      });
  };

  const autoDownloadGstr8a = () => {
    const payload = {
      gstin: orderData?.gstin,
      ret_period: orderData?.ret_period,
    };

    axios
      .post(`/gstr8a_auto_download_passthrough`, payload)
      .then((res) => {
        const d = res.data;
        if (d.status === false) {
          toast.error(d.message);
        } else {
          toast.success(d.message || "Request processed successfully");
        }
        history.goBack();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Unexpected Error.");
        history.goBack();
      });
  };

  const autoDownloadIms = () => {
    axios
      .post(`/ims_auto_download`, {
        business_entity_id: orderData?.business_entity_id,
      })
      .then((res) => {
        if (res.data.status === "error") {
          toast.error(res.data.message);
        } else {
          toast.success(res.data.message);
        }
        history.goBack();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "An unexpected error occurred.");
        history.goBack();
      });
  };

  const generateGstr1FilingReport = () => {
    axios
      .post(`/report_generation`, {
        functionality: "report_generation",
        business_entity_id: orderData?.business_entity_id,
        report_month: orderData?.report_month,
        report_year: orderData?.report_year,
        option: orderData?.option,
        is_previous_month: orderData?.is_previous_month,
        recon_run_with_prev: false,
        gstin: orderData?.gstin,
      })
      .then((res) => {
        toast.success(res.data?.message || "GSTR-1 filing report generated successfully");
        history.goBack();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Report generation failed");
        history.goBack();
      });
  };

  // const handleGoBack = async (event) => {
  //   if (orderData?.description === "PAN_TO_TAN_FETCHING") {
  //     history.goBack();
  //   } else if (orderData?.description === "26AS_FORM_AUTO_DOWNLOAD") {
  //     history.goBack();
  //   } else {
  //     history.replace("/landingcws");
  //   }
  // };

  const handleGoBack = async (event) => {
    if (
      orderData?.description === "PAN_TO_TAN_FETCHING" ||
      orderData?.description === "PAN_TO_TAN_FETCHING_VENDOR" ||
      orderData?.description === "GSTR1_FILING_REPORT_GENERATION" ||
      orderData?.description === "26AS_FORM_AUTO_DOWNLOAD" ||
      orderData?.description === "GSTR1_AUTO_DOWNLOAD" ||
      orderData?.description === "GSTR2A_AUTO_DOWNLOAD" ||
      orderData?.description === "GSTR2B_AUTO_DOWNLOAD" ||
      orderData?.description === "GSTR3B_AUTO_DOWNLOAD" ||
      orderData?.description === "GSTR8A_AUTO_DOWNLOAD" ||
      orderData?.description === "IMS_AUTO_DOWNLOAD"
    ) {
      history.goBack();
    } else {
      history.replace("/landingcws");
    }
  };

  const formatIndianNumber = (num) => {
    const n = Number(num).toFixed(2);
    const [integer, decimal] = n.split(".");
    const lastThree = integer.slice(-3);
    const remaining = integer.slice(0, -3);
    const formatted =
      remaining !== ""
        ? remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree
        : lastThree;
    return `${formatted}.${decimal}`;
  };

  // ── Fetches entity data and populates localStorage before opening MSA dialog ──
  const handleTermsCheckboxChange = async (e) => {
    if (e.target.checked) {
      try {
        const res = await axios.get(
          `/get_complete_entity_data/${localStorage.getItem("business_entity_id")}`,
        );
        const entity = res.data.Entity;
        if (entity) {
          localStorage.setItem("msa_entity_name", entity.entity_name || "");
          localStorage.setItem(
            "msa_constitution",
            entity.constitution_id || "",
          );
          localStorage.setItem("msa_cin", entity.cin || "");
          localStorage.setItem("msa_pan", entity.pan || "");
          localStorage.setItem(
            "msa_business_sector",
            entity.business_sector_id || "",
          );
          const addressParts = [
            entity.flat_no,
            entity.road_street_name,
            entity.area,
            entity.city,
            entity.state,
            entity.country,
            entity.pincode,
          ].filter(Boolean);
          localStorage.setItem("msa_address", addressParts.join(", "));
        }
        setTermsDialogOpen(true);
      } catch (error) {
        console.error("Failed to fetch entity data:", error);
        // toast.error("Failed to load entity details. Please try again.", {
        //   autoClose: 3000,
        // });
      }
    } else {
      setTermsChecked(false);
    }
  };

  const isSubscriptionOrder =
    orderData?.description !== "PAN_TO_TAN_FETCHING" &&
    orderData?.description !== "PAN_TO_TAN_FETCHING_VENDOR" &&
    orderData?.description !== "26AS_FORM_AUTO_DOWNLOAD" &&
    orderData?.description !== "GSTR1_AUTO_DOWNLOAD" &&
    orderData?.description !== "GSTR2A_AUTO_DOWNLOAD" &&
    orderData?.description !== "GSTR2B_AUTO_DOWNLOAD" &&
    orderData?.description !== "GSTR3B_AUTO_DOWNLOAD" &&
    orderData?.description !== "GSTR8A_AUTO_DOWNLOAD" &&
    orderData?.description !== "IMS_AUTO_DOWNLOAD" &&
    orderData?.description !== "GSTR1_FILING_REPORT_GENERATION";

  const handlePayment = async (event) => {
    const errors = {};
    if (!billingDetails.name) errors.name = "This field is required";
    if (!billingDetails.gstin) errors.gstin = "This field is required";
    if (!billingDetails.state) errors.state = "This field is required";
    if (!billingDetails.country) errors.country = "This field is required";
    setFieldErrors(errors);

    if (
      !billingDetails.name ||
      !billingDetails.email ||
      !billingDetails.mobile ||
      !billingDetails.gstin ||
      !billingDetails.state ||
      !billingDetails.country
    ) {
      toast.error("Please fill all required billing details.");
      return;
    }
    if (!validBillingEmail) {
      toast.error("Please enter a valid email domain.");
      return;
    }

    try {
      setPayLoading(true);
      const orderDetails = await axios.post("/create_order", {
        total: totalAmount * 100,
        gst_charges: gstCharges,
        entity_type: orderData?.description,
        quantity: orderData?.features[0]?.qty,
        business_entity_id: localStorage.getItem("business_entity_id"),
        name: billingDetails.name,
        email: billingDetails.email,
        phone: billingDetails.mobile,
        address: billingDetails.address,
        pincode: billingDetails.pinCode,
        state: billingDetails.state,
        country: billingDetails.country,
        city: billingDetails.city,
        gst: billingDetails.gst,
        from_date: orderData?.fromRetPeriod ?? null,
      });
      if (!orderDetails.data.id) {
        throw new Error("order id not generated");
      }

      const options = {
        key: process.env.REACT_APP_RAZORPAY_ID,
        amount: totalAmount,
        currency: "INR",
        name: "Cappitall Want Network",
        config: {
          display: {
            hide: [
              { method: "emi" },
              { method: "wallet" },
              { method: "paylater" },
            ],
            preferences: { show_default_blocks: true },
          },
        },
        description: orderData?.description,
        image: CWS,
        order_id: orderDetails.data.id,
        handler: () => postPaymentHandler(orderDetails.data.id),
        prefill: {
          name: localStorage.getItem("entity_name"),
          email: localStorage.getItem("EmailId"),
          contact: billingDetails.mobile,
          // contact: localStorage.getItem("contact"),
        },
        theme: {
          color: "#03406d",
        },
      };
      const rzp1 = new window.Razorpay(options);
      rzp1.open();
      event.preventDefault();
    } catch (error) {
      console.error(error);
    } finally {
      setPayLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f0f4f8",
        p: { xs: 2, md: 4 },
        fontFamily: "Dosis, sans-serif",
      }}
    >
      {/* Header Steps */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 4,
          fontFamily: "Dosis, sans-serif",
          fontSize: "16px",
          color: "#1a6fbf",
          fontWeight: 600,
        }}
      >
        <IconButton onClick={() => handleGoBack()} size="small">
          <ArrowBackIcon sx={{ color: "#1a6fbf" }} />
        </IconButton>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 4,
          alignItems: "flex-start",
        }}
      >
        {/* LEFT - Billing Details */}
        <Box
          sx={{
            flex: "0 0 45%",
            bgcolor: "#fff",
            borderRadius: "12px",
            p: 4,
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Dosis, sans-serif",
              fontWeight: 700,
              mb: 3,
              color: "#1a3c5e",
            }}
          >
            Billing Details
          </Typography>

          {/* Name */}
          <Box sx={{ mb: 2.5 }}>
            <Typography
              sx={{
                fontFamily: "Dosis, sans-serif",
                mb: 0.5,
                color: "#555",
                fontSize: "16px",
              }}
            >
              Name <span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              size="small"
              name="name"
              placeholder="Your name / Organisation name"
              value={billingDetails.name}
              onChange={(e) => {
                handleBillingChange(e);
                if (e.target.value)
                  setFieldErrors((prev) => ({ ...prev, name: "" }));
              }}
              inputProps={{ maxLength: 200 }}
              onKeyPress={(event) => {
                if (!/^[a-zA-Z\s]$/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              error={
                !!fieldErrors.name ||
                (billingDetails.name !== "" && billingDetails.name.length > 255)
              }
              helperText={
                fieldErrors.name
                  ? fieldErrors.name
                  : billingDetails.name !== "" &&
                    billingDetails.name.length > 200
                    ? "Name must not exceed 200 characters"
                    : ""
              }
              sx={{
                "& .MuiInputBase-root": {
                  fontFamily: "Dosis, sans-serif",
                  borderRadius: "8px",
                },
              }}
            />
          </Box>

          {/* Email + GSTIN */}
          <Box sx={{ display: "flex", gap: 2, mb: 2.5 }}>
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  mb: 0.5,
                  color: "#555",
                  fontSize: "16px",
                }}
              >
                Email address
              </Typography>
              <TextField
                fullWidth
                size="small"
                name="email"
                placeholder="Enter your email"
                value={billingDetails.email}
                onChange={handleBillingChange}
                inputProps={{ maxLength: 200 }}
                onKeyPress={(event) => {
                  if (event.key === " ") {
                    event.preventDefault();
                  }
                }}
                error={!validBillingEmail}
                helperText={!validBillingEmail ? "Invalid Domain" : ""}
                sx={{
                  "& .MuiInputBase-root": {
                    fontFamily: "Dosis, sans-serif",
                    borderRadius: "8px",
                  },
                }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
              >
                <Typography
                  sx={{
                    fontFamily: "Dosis, sans-serif",
                    color: "#555",
                    fontSize: "16px",
                  }}
                >
                  GSTIN No.<span style={{ color: "red" }}>*</span>
                </Typography>
              </Box>
              <TextField
                fullWidth
                size="small"
                name="gstin"
                placeholder="Enter GSTIN No."
                value={billingDetails.gstin}
                onChange={(e) => {
                  handleBillingChange(e);
                  if (e.target.value)
                    setFieldErrors((prev) => ({ ...prev, gstin: "" }));
                }}
                inputProps={{ maxLength: 15 }}
                error={
                  !!fieldErrors.gstin ||
                  (billingDetails.gstin !== "" &&
                    !/^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[CZ]{1}[0-9A-Za-z]{1}$/.test(
                      billingDetails.gstin,
                    ))
                }
                helperText={
                  fieldErrors.gstin
                    ? fieldErrors.gstin
                    : billingDetails.gstin !== "" &&
                      !/^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[CZ]{1}[0-9A-Za-z]{1}$/.test(
                        billingDetails.gstin,
                      )
                      ? "Must be a Valid GSTN number"
                      : ""
                }
                sx={{
                  "& .MuiInputBase-root": {
                    fontFamily: "Dosis, sans-serif",
                    borderRadius: "8px",
                  },
                }}
              />
            </Box>
          </Box>

          {/* Mobile + Address */}
          <Box sx={{ display: "flex", gap: 2, mb: 2.5 }}>
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  mb: 0.5,
                  color: "#555",
                  fontSize: "16px",
                }}
              >
                Mobile No.
              </Typography>
              <TextField
                fullWidth
                size="small"
                name="mobile"
                placeholder="Enter Mobile No. excluding ISD, STD code"
                value={billingDetails.mobile}
                onChange={handleBillingChange}
                inputProps={{ maxLength: 10 }}
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                error={
                  billingDetails.mobile !== "" &&
                  !/^[1-9]{1}[0-9]{9}$/.test(billingDetails.mobile)
                }
                helperText={
                  billingDetails.mobile !== "" &&
                    !/^[1-9]{1}[0-9]{9}$/.test(billingDetails.mobile)
                    ? "Enter a valid 10-digit mobile number"
                    : ""
                }
                sx={{
                  "& .MuiInputBase-root": {
                    fontFamily: "Dosis, sans-serif",
                    borderRadius: "8px",
                  },
                }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  mb: 0.5,
                  color: "#555",
                  fontSize: "16px",
                }}
              >
                Address
              </Typography>
              <TextField
                fullWidth
                size="small"
                name="address"
                placeholder="This address will print on your invoice"
                value={billingDetails.address}
                onChange={handleBillingChange}
                inputProps={{ maxLength: 450 }}
                sx={{
                  "& .MuiInputBase-root": {
                    fontFamily: "Dosis, sans-serif",
                    borderRadius: "8px",
                  },
                }}
              />
            </Box>
          </Box>

          {/* Country + State */}
          <Box sx={{ display: "flex", gap: 2, mb: 2.5 }}>
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  mb: 0.5,
                  color: "#555",
                  fontSize: "16px",
                }}
              >
                Country <span style={{ color: "red" }}>*</span>
              </Typography>
              <Autocomplete
                options={
                  billingDetails.state &&
                    states.some((s) => s.name === billingDetails.state)
                    ? countries.filter((c) => c.name === billingDetails.country)
                    : countries
                }
                getOptionLabel={(option) => option.name || ""}
                value={
                  countries.find((c) => c.name === billingDetails.country) ||
                  null
                }
                onChange={(event, newValue) => {
                  setBillingDetails((prev) => ({
                    ...prev,
                    country: newValue ? newValue.name : "",
                    state: "",
                  }));
                  if (newValue && newValue.name) {
                    getStatesByCountry(newValue.name);
                  } else {
                    setStates([]);
                    setStatesAvailable(false);
                  }
                  if (newValue)
                    setFieldErrors((prev) => ({ ...prev, country: "" }));
                }}
                onInputChange={(event, value, reason) => {
                  if (reason === "input" && value && value.trim() !== "") {
                    getStatesByCountry(value.trim());
                  }
                  if (
                    reason === "clear" ||
                    (reason === "input" && value.trim() === "")
                  ) {
                    setStates([]);
                    setStatesAvailable(false);
                    setBillingDetails((prev) => ({
                      ...prev,
                      state: "",
                      country: "",
                    }));
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Select your country"
                    error={!!fieldErrors.country}
                    helperText={fieldErrors.country || ""}
                    sx={{
                      "& .MuiInputBase-root": {
                        fontFamily: "Dosis, sans-serif",
                        borderRadius: "8px",
                      },
                    }}
                  />
                )}
                onBlur={(event) => {
                  const inputValue = event.target.value;
                  const currentCountry = billingDetails.country;
                  if (inputValue && !currentCountry) {
                    setTimeout(() => {
                      if (event.target) event.target.value = "";
                    }, 0);
                  }
                }}
                blurOnSelect={true}
                clearOnBlur={false}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  mb: 0.5,
                  color: "#555",
                  fontSize: "16px",
                }}
              >
                State <span style={{ color: "red" }}>*</span>
              </Typography>
              {statesAvailable ? (
                <Autocomplete
                  options={states}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    states.find((s) => s.value === billingDetails.state) || null
                  }
                  onOpen={
                    termsDialogOpen ? (e) => e.preventDefault() : undefined
                  }
                  open={termsDialogOpen ? false : undefined}
                  onChange={(event, newValue) => {
                    if (termsDialogOpen) return;
                    setBillingDetails((prev) => ({
                      ...prev,
                      state: newValue ? newValue.value : "",
                    }));
                    if (newValue)
                      setFieldErrors((prev) => ({ ...prev, state: "" }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder="Select state"
                      error={!!fieldErrors.state}
                      inputProps={{
                        ...params.inputProps,
                        readOnly: termsDialogOpen ? true : false,
                      }}
                      helperText={fieldErrors.state || ""}
                      sx={{
                        "& .MuiInputBase-root": {
                          fontFamily: "Dosis, sans-serif",
                          borderRadius: "8px",
                        },
                      }}
                    />
                  )}
                  onBlur={() => { }}
                  blurOnSelect={true}
                  clearOnBlur={true}
                  freeSolo={false}
                />
              ) : (
                <TextField
                  fullWidth
                  size="small"
                  name="state"
                  placeholder="Enter your state"
                  value={billingDetails.state || ""}
                  onChange={(e) => {
                    handleBillingChange(e);
                    if (e.target.value)
                      setFieldErrors((prev) => ({ ...prev, state: "" }));
                  }}
                  onKeyPress={(event) => {
                    if (!/^[a-zA-Z\s]$/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  inputProps={{ maxLength: 50 }}
                  error={!!fieldErrors.state}
                  helperText={fieldErrors.state || ""}
                  sx={{
                    "& .MuiInputBase-root": {
                      fontFamily: "Dosis, sans-serif",
                      borderRadius: "8px",
                    },
                  }}
                />
              )}
            </Box>
          </Box>

          {/* City + Pin Code */}
          <Box sx={{ display: "flex", gap: 2, mb: 2.5 }}>
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  mb: 0.5,
                  color: "#555",
                  fontSize: "16px",
                }}
              >
                City
              </Typography>
              <TextField
                fullWidth
                size="small"
                name="city"
                placeholder="Enter your city"
                value={billingDetails.city || ""}
                inputProps={{ maxLength: 50 }}
                onChange={handleBillingChange}
                sx={{
                  "& .MuiInputBase-root": {
                    fontFamily: "Dosis, sans-serif",
                    borderRadius: "8px",
                  },
                }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  mb: 0.5,
                  color: "#555",
                  fontSize: "16px",
                }}
              >
                Pin Code
              </Typography>
              <TextField
                fullWidth
                size="small"
                name="pinCode"
                placeholder="Enter your area Pin Code"
                value={billingDetails.pinCode}
                onChange={handleBillingChange}
                inputProps={{ maxLength: 6 }}
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                error={
                  billingDetails.pinCode !== "" &&
                  !/^[0-9]{6}$/.test(billingDetails.pinCode)
                }
                helperText={
                  billingDetails.pinCode !== "" &&
                    !/^[0-9]{6}$/.test(billingDetails.pinCode)
                    ? "Must be a 6-digit pincode"
                    : ""
                }
                sx={{
                  "& .MuiInputBase-root": {
                    fontFamily: "Dosis, sans-serif",
                    borderRadius: "8px",
                  },
                }}
              />
            </Box>
          </Box>
          {isSubscriptionOrder && (
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                mb: 1.5,
                gap: 1,
              }}
            >
              <input
                type="checkbox"
                id="dataMigrationCheckbox"
                checked={dataMigrationChecked}
                onChange={(e) => setDataMigrationChecked(e.target.checked)}
                style={{
                  width: "16px",
                  height: "16px",
                  cursor: "pointer",
                  accentColor: "#1a3c5e",
                  marginTop: "6px",
                  flexShrink: 0,
                }}
              />
              <label
                htmlFor="dataMigrationCheckbox"
                style={{
                  fontFamily: "Dosis, sans-serif",
                  fontSize: "15px",
                  color: "#555",
                  cursor: "pointer",
                  paddingTop: "4px",
                }}
              >
                <strong>Migrate trial data to paid account</strong>
                <br />
                <span
                  style={{ fontWeight: 400, fontSize: "14px", color: "#777" }}
                >
                  Includes all data created, uploaded, or used during your
                  trial.
                  <br />
                  If selected, your data will be transferred to your paid
                  account.
                  <br />
                  If not selected, all trial data will be permanently deleted,
                  and we will not retain or be liable for it.
                </span>
              </label>
            </Box>
          )}
          {/* Terms & Conditions Checkbox */}
          {isSubscriptionOrder && (
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                mb: 1.5,
                gap: 1,
              }}
            >
              <input
                type="checkbox"
                id="orderTermsCheckbox"
                checked={termsChecked}
                // onChange={(e) => {
                //   if (e.target.checked) {
                //     setTermsDialogOpen(true);
                //   } else {
                //     setTermsChecked(false);
                //   }
                // }}
                onChange={handleTermsCheckboxChange}
                style={{
                  width: "16px",
                  height: "16px",
                  cursor: "pointer",
                  accentColor: "#1a3c5e",
                  marginTop: "6px",
                  flexShrink: 0,
                }}
              />
              <label
                htmlFor="orderTermsCheckbox"
                style={{
                  fontFamily: "Dosis, sans-serif",
                  fontSize: "15px",
                  color: "#555",
                  cursor: "pointer",
                  paddingTop: "4px",
                }}
              >
                By clicking <strong>'I Agree'</strong>, you confirm that you
                have read and agreed to our Master Services Agreement, including
                all Schedules and Terms of Business.
              </label>
            </Box>
          )}

          <Button
            variant="contained"
            fullWidth
            disabled={payLoading || (isSubscriptionOrder && !termsChecked)}
            onClick={handlePayment}
            sx={{
              mt: 1.5,
              fontFamily: "Dosis, sans-serif",
              fontWeight: 700,
              fontSize: "16px",
              borderRadius: "8px",
              py: 1.5,
              backgroundColor: "#1a3c5e",
              "&:hover": { backgroundColor: "#153250" },
              "&.Mui-disabled": { backgroundColor: "#ccc" },
            }}
          >
            {payLoading ? "Processing..." : "Pay Now"}
          </Button>
        </Box>

        {/* RIGHT COLUMN - Order Summary + Additional Features stacked */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 4,
          }}
        >
          {/* Order Summary */}
          <Box
            sx={{
              bgcolor: "#fff",
              borderRadius: "12px",
              p: 3,
              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  fontSize: "15px",
                  fontWeight: 700,
                  color: "#1a3c5e",
                }}
              >
                Order Summary
              </Typography>
              {isSubscriptionOrder && orderData.plan_name && (
                <Box
                  sx={{
                    backgroundColor: "#e8f0fe",
                    border: "1px solid #1a3c5e",
                    borderRadius: "8px",
                    px: 2,
                    py: 0.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Dosis, sans-serif",
                      fontSize: "18px",
                      color: "#555",
                      fontWeight: 800,
                    }}
                  >
                    Option Selected:
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Dosis, sans-serif",
                      fontSize: "19px",
                      fontWeight: 900,
                      color: "#1a3c5e",
                    }}
                  >
                    {orderData.plan_name}
                  </Typography>
                </Box>
              )}
            </Box>
            {/* Features Table */}
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "16px",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f5f7fb" }}>
                  <th
                    style={{
                      fontFamily: "Dosis, sans-serif",
                      fontSize: "16px",
                      color: "#1a3c5e",
                      textAlign: "left",
                      padding: "8px 10px",
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    Particulars
                  </th>
                  <th
                    style={{
                      fontFamily: "Dosis, sans-serif",
                      fontSize: "16px",
                      color: "#1a3c5e",
                      textAlign: "center",
                      padding: "8px 10px",
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    Qty
                  </th>
                  <th
                    style={{
                      fontFamily: "Dosis, sans-serif",
                      fontSize: "16px",
                      color: "#1a3c5e",
                      textAlign: "right",
                      padding: "8px 10px",
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {features.map((item, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        fontFamily: "Dosis, sans-serif",
                        fontSize: "17px",
                        color: "#555",
                        padding: "8px 10px",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      {item.particulars}
                    </td>
                    <td
                      style={{
                        fontFamily: "Dosis, sans-serif",
                        fontSize: "17px",
                        color: "#555",
                        textAlign: "center",
                        padding: "8px 10px",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      {item.qty}
                    </td>
                    <td
                      style={{
                        fontFamily: "Dosis, sans-serif",
                        fontSize: "17px",
                        color: "#555",
                        textAlign: "right",
                        padding: "8px 10px",
                        borderBottom: "1px solid #f0f0f0",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          width: "100%",
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            width: "24px",
                            textAlign: "left",
                            flexShrink: 0,
                          }}
                        >
                          ₹
                        </span>
                        <span
                          style={{
                            width: "100px",
                            textAlign: "right",
                            flexShrink: 0,
                          }}
                        >
                          {formatIndianNumber(item.amount)}
                        </span>
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Totals */}
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
            >
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  color: "#333",
                  fontSize: "1.5rem",
                  fontWeight: 600,
                }}
              >
                Sub total
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  fontWeight: 600,
                  fontSize: "1.5rem",
                  display: "inline-flex",
                  minWidth: "160px",
                  justifyContent: "flex-end",
                }}
              >
                <span style={{ minWidth: "16px", textAlign: "left" }}>₹</span>
                <span style={{ minWidth: "120px", textAlign: "right" }}>
                  {formatIndianNumber(baseAmount)}
                </span>
              </Typography>
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
            >
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  color: "#333",
                  fontSize: "1.5rem",
                  fontWeight: 600,
                }}
              >
                GST (18%)
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  fontWeight: 600,
                  fontSize: "1.5rem",
                  display: "inline-flex",
                  minWidth: "160px",
                  justifyContent: "flex-end",
                }}
              >
                <span style={{ minWidth: "16px", textAlign: "left" }}>₹</span>
                <span style={{ minWidth: "120px", textAlign: "right" }}>
                  {formatIndianNumber(gstCharges)}
                </span>
              </Typography>
            </Box>

            <Divider sx={{ my: 1.5 }} />

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  fontWeight: 700,
                  fontSize: "1.5rem",
                  color: "#1a3c5e",
                }}
              >
                Total
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  fontWeight: 700,
                  fontSize: "1.5rem",
                  color: "#1a3c5e",
                  display: "inline-flex",
                  minWidth: "160px",
                  justifyContent: "flex-end",
                }}
              >
                <span style={{ minWidth: "16px", textAlign: "left" }}>₹</span>
                <span style={{ minWidth: "120px", textAlign: "right" }}>
                  {formatIndianNumber(totalAmount)}
                </span>
              </Typography>
            </Box>
          </Box>

          {/* Additional Features */}
          {addOn.length > 0 && (
            <Box
              sx={{
                bgcolor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Dosis, sans-serif",
                  fontSize: "15px",
                  fontWeight: 700,
                  color: "#1a3c5e",
                  mb: 0.5,
                }}
              >
                Additional Features
              </Typography>
              {/* Addon Table */}
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginBottom: "16px",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f5f7fb" }}>
                    <th
                      style={{
                        fontFamily: "Dosis, sans-serif",
                        fontSize: "16px",
                        color: "#1a3c5e",
                        textAlign: "left",
                        padding: "8px 10px",
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      Particulars (Billed on actuals)
                    </th>
                    <th
                      style={{
                        fontFamily: "Dosis, sans-serif",
                        fontSize: "16px",
                        color: "#1a3c5e",
                        textAlign: "right",
                        padding: "8px 10px",
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {addOn.map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          fontFamily: "Dosis, sans-serif",
                          fontSize: "17px",
                          color: "#555",
                          padding: "8px 10px",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                      >
                        {item.particulars}
                      </td>
                      <td
                        style={{
                          fontFamily: "Dosis, sans-serif",
                          fontSize: "17px",
                          color: "#555",
                          textAlign: "right",
                          padding: "8px 10px",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-flex",
                            width: "100%",
                            justifyContent: "flex-end",
                          }}
                        >
                          <span style={{ minWidth: "16px", textAlign: "left" }}>
                            ₹
                          </span>
                          <span
                            style={{ minWidth: "120px", textAlign: "right" }}
                          >
                            {formatIndianNumber(item.amount)}
                          </span>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          )}
        </Box>
      </Box>
      {termsDialogOpen && (
        <Dialog
          open={termsDialogOpen}
          onClose={() => {
            setTermsChecked(false);
            setTermsDialogOpen(false);
          }}
          fullWidth={true}
          maxWidth="lg"
          PaperProps={{
            style: {
              padding: "25px",
              borderRadius: "6px",
              boxShadow: "0 4px 8px rgba(239, 232, 232, 0.1)",
              height: "90vh",
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Dosis, sans-serif",
                fontSize: "20px",
                fontWeight: 700,
                color: "#1a3c5e",
              }}
            >
              Master Services Agreement
            </Typography>
          </Box>

          <Box sx={{ flex: 1, overflow: "hidden", mb: 2 }}>
            {msaUrl ? (
              <iframe
                src={msaUrl}
                width="100%"
                height="100%"
                frameBorder="0"
                scrolling="auto"
                allowFullScreen
                title="Master Services Agreement"
                style={{ border: "none", minHeight: "500px" }}
              />
            ) : (
              <MSA
                onPDFDownloaded={() => {
                  setTermsChecked(true);
                  setTermsDialogOpen(false);
                }}
                onPDFGenerated={({
                  base64,
                  name,
                  email,
                  designation,
                  mobile,
                }) => {
                  setMsaPdfBase64(base64);
                  setMsaSignedName(name);
                  setMsaSignedEmail(email);
                  setMsaSignedDesignation(designation);
                  setMsaSignedPhone(mobile);
                }}
              />
            )}
          </Box>

          {msaUrl && (
            <>
              {showAuthModal && (
                <Box
                  sx={{
                    position: "fixed",
                    inset: 0,
                    background: "rgba(0,0,0,0.55)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 2000,
                    padding: "20px",
                  }}
                >
                  <Box
                    sx={{
                      background: "#fff",
                      borderRadius: "4px",
                      boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
                      width: "100%",
                      maxWidth: "520px",
                      padding: "36px 40px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Libre Baskerville, serif",
                        fontSize: "13px",
                        fontWeight: 700,
                        color: "#1a3a5c",
                        mb: 2,
                        pb: 2,
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      Cappitall <span>Want</span> Network
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Libre Baskerville, serif",
                        fontSize: "18px",
                        fontWeight: 700,
                        color: "#111",
                        mb: 1,
                      }}
                    >
                      Confirm Your Details
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        color: "#666",
                        mb: 3,
                        lineHeight: 1.5,
                      }}
                    >
                      Please enter the authorized signatory details. By clicking{" "}
                      <strong>"I Agree"</strong>, you confirm you have read and
                      accept this Master Services Agreement in full.
                    </Typography>

                    {/* Full Name */}
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 600,
                          color: "#444",
                          textTransform: "uppercase",
                          mb: 0.5,
                        }}
                      >
                        Full Name *
                      </Typography>
                      <TextField
                        fullWidth
                        size="small"
                        placeholder="e.g. Rajesh Kumar"
                        value={iframeAuthForm.name}
                        onChange={(e) => {
                          const onlyAlpha = e.target.value.replace(
                            /[^a-zA-Z\s]/g,
                            "",
                          );
                          setIframeAuthForm((f) => ({
                            ...f,
                            name: onlyAlpha.slice(0, 200),
                          }));
                          setIframeAuthErrors((e2) => ({ ...e2, name: "" }));
                        }}
                        error={!!iframeAuthErrors.name}
                        helperText={iframeAuthErrors.name || ""}
                        sx={{ "& .MuiInputBase-root": { borderRadius: "3px" } }}
                      />
                    </Box>

                    {/* Designation */}
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 600,
                          color: "#444",
                          textTransform: "uppercase",
                          mb: 0.5,
                        }}
                      >
                        Designation *
                      </Typography>
                      <TextField
                        fullWidth
                        size="small"
                        placeholder="e.g. Managing Partner"
                        value={iframeAuthForm.designation}
                        onChange={(e) => {
                          setIframeAuthForm((f) => ({
                            ...f,
                            designation: e.target.value.slice(0, 200),
                          }));
                          setIframeAuthErrors((e2) => ({
                            ...e2,
                            designation: "",
                          }));
                        }}
                        error={!!iframeAuthErrors.designation}
                        helperText={iframeAuthErrors.designation || ""}
                        sx={{ "& .MuiInputBase-root": { borderRadius: "3px" } }}
                      />
                    </Box>

                    {/* Mobile */}
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 600,
                          color: "#444",
                          textTransform: "uppercase",
                          mb: 0.5,
                        }}
                      >
                        Mobile Number *
                      </Typography>
                      <TextField
                        fullWidth
                        size="small"
                        placeholder="e.g. 9876543210"
                        value={iframeAuthForm.mobile}
                        onChange={(e) => {
                          const onlyNums = e.target.value.replace(
                            /[^0-9]/g,
                            "",
                          );
                          setIframeAuthForm((f) => ({
                            ...f,
                            mobile: onlyNums.slice(0, 10),
                          }));
                          setIframeAuthErrors((e2) => ({ ...e2, mobile: "" }));
                        }}
                        error={!!iframeAuthErrors.mobile}
                        helperText={iframeAuthErrors.mobile || ""}
                        sx={{ "& .MuiInputBase-root": { borderRadius: "3px" } }}
                      />
                    </Box>

                    {/* Email */}
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 600,
                          color: "#444",
                          textTransform: "uppercase",
                          mb: 0.5,
                        }}
                      >
                        Email Address *
                      </Typography>
                      <TextField
                        fullWidth
                        size="small"
                        placeholder="e.g. rajesh@yourfirm.com"
                        value={iframeAuthForm.email}
                        onKeyPress={(e) => {
                          if (e.key === " ") e.preventDefault();
                        }}
                        onChange={(e) => {
                          const val = e.target.value;
                          setIframeAuthForm((f) => ({ ...f, email: val }));
                          setIframeAuthErrors((e2) => ({ ...e2, email: "" }));
                          const emailPattern =
                            /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
                          if (emailPattern.test(val)) {
                            axios
                              .get(`/validate_email/${val}`)
                              .then((res) => {
                                setIframeValidEmail(res.data);
                              })
                              .catch(() => {
                                setIframeValidEmail(true);
                              });
                          } else {
                            setIframeValidEmail(true);
                          }
                        }}
                        error={!!iframeAuthErrors.email || !iframeValidEmail}
                        helperText={
                          iframeAuthErrors.email
                            ? iframeAuthErrors.email
                            : !iframeValidEmail
                              ? "Invalid Domain"
                              : ""
                        }
                        sx={{ "& .MuiInputBase-root": { borderRadius: "3px" } }}
                      />
                    </Box>

                    <Box sx={{ display: "flex", gap: 1.5, mt: 3 }}>
                      <Button
                        variant="outlined"
                        fullWidth
                        onClick={() => {
                          setShowAuthModal(false);
                          setIframeAuthForm({
                            name: "",
                            designation: "",
                            mobile: "",
                            email: "",
                          });
                          setIframeAuthErrors({});
                          setIframeValidEmail(true);
                        }}
                        sx={{
                          borderRadius: "3px",
                          borderColor: "#d0d0d0",
                          color: "#555",
                          fontWeight: 600,
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={() => {
                          const errs = {};
                          if (!iframeAuthForm.name.trim())
                            errs.name = "Full name is required";
                          if (!iframeAuthForm.designation.trim())
                            errs.designation = "Designation is required";
                          if (!iframeAuthForm.mobile.trim())
                            errs.mobile = "Mobile number is required";
                          else if (
                            !/^[1-9]{1}[0-9]{9}$/.test(
                              iframeAuthForm.mobile.trim(),
                            )
                          )
                            errs.mobile =
                              "Enter a valid 10-digit mobile number";
                          if (!iframeAuthForm.email.trim())
                            errs.email = "Email is required";
                          else if (
                            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                              iframeAuthForm.email.trim(),
                            )
                          )
                            errs.email = "Enter a valid email address";
                          if (!iframeValidEmail) errs.email = "Invalid Domain";
                          if (Object.keys(errs).length) {
                            setIframeAuthErrors(errs);
                            return;
                          }

                          setMsaSignedName(iframeAuthForm.name);
                          setMsaSignedEmail(iframeAuthForm.email);
                          setMsaSignedDesignation(iframeAuthForm.designation);
                          setMsaSignedPhone(iframeAuthForm.mobile);
                          setShowAuthModal(false);
                          setIframeAuthForm({
                            name: "",
                            designation: "",
                            mobile: "",
                            email: "",
                          });
                          setIframeAuthErrors({});
                          setIframeValidEmail(true);
                          setTermsChecked(true);
                          setTermsDialogOpen(false);
                        }}
                        sx={{
                          borderRadius: "3px",
                          backgroundColor: "#1a3c5e",
                          fontWeight: 700,
                          "&:hover": { backgroundColor: "#153250" },
                        }}
                      >
                        ✓ I Agree
                      </Button>
                    </Box>
                  </Box>
                </Box>
              )}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                  pt: 1,
                  borderTop: "1px solid #e0e0e0",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => {
                    setTermsChecked(false);
                    setTermsDialogOpen(false);
                  }}
                  sx={{
                    fontFamily: "Dosis, sans-serif",
                    fontWeight: 600,
                    borderRadius: "8px",
                    borderColor: "#d32f2f",
                    color: "#d32f2f",
                    "&:hover": {
                      backgroundColor: "#fdecea",
                      borderColor: "#d32f2f",
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => setShowAuthModal(true)}
                  sx={{
                    fontFamily: "Dosis, sans-serif",
                    fontWeight: 700,
                    borderRadius: "8px",
                    backgroundColor: "#1a3c5e",
                    "&:hover": { backgroundColor: "#153250" },
                  }}
                >
                  I Agree
                </Button>
              </Box>
            </>
          )}
        </Dialog>
      )}
    </Box>
  );
};

export default OrderSummary;
